import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3nxmfbpynu: FaireBrandEntity = {
  token: "b_3nxmfbpynu",
  type: "brand",
  name: "Ciao Pappy",
  avatarUrl:
    "https://cdn.faire.com/fastly/d923cbb39211d2e5705c31ad270941520d635497722096c5587a6d4a909c64e1.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/237865fd6b859254e73f797a8f442b194b93e5e0d7c140f6ab00e7d3b7f471ea.png",
  logoUrl:
    "https://cdn.faire.com/fastly/d923cbb39211d2e5705c31ad270941520d635497722096c5587a6d4a909c64e1.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/237865fd6b859254e73f797a8f442b194b93e5e0d7c140f6ab00e7d3b7f471ea.png",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 90,
  rating: 5,
  reviewCount: 8,
  isInsider: true,
  description:
    "Ciao Pappy® is a modern pantry lifestyle brand specializing in premium marinaras inspired by the Italian and California Coast. Our Italifornia™ sauces expand a dated category, speak to today's generation with our clean label certifications, and elevate food quality by using locally sourced ingredients with no added sugar, pastes, or concentrates.\n\nCiao Pappy is creating a new family recipe by modernizing Italian food classics, introducing a fresh Italian-American story, and adding an accent to your pantry staples.\n\nEach year, Ciao Pappy makes annual donations to raise awareness of ageism. By 2026, we pledge to employ 25% of our team over the age of 50.",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:19:23.575Z",
    importedBy: "entity-db-cli",
  },
};
